import * as main_ts from './main.ts'
import * as index_html from './index.html'
import * as app_component_html from './app.component.html'
import * as app_component_ts from './app.component.ts'
import * as app_module_ts from './app.module.ts'

export default [
  index_html,
  main_ts,
  app_component_html,
  app_component_ts,
  app_module_ts,
]
